<div class="publish-to-valorem" *ngIf="currentStep != 0">
  <div class="valorem-publish-header">
    <svg-icon src='./assets/icons/close-outline.svg'
              class="svg-icon-large valorem-close-icon" (click)="onCloseClicked()" title="{{ 'raci.publishToValorem.close' | translate | uppercase }}"></svg-icon>
  </div>
  <div class="content-title">
    {{'raci.publishToValorem.title' | translate}}
  </div>
  <div class="valorem-content" *ngIf="currentStep == 1">
    <div class="content-body" [innerHTML]="'raci.publishToValorem.description' | translate">
    </div>
    <div class="footer-wraper">
      <button kendoButton class="footer-button" (click)="publishTovalorem()">{{'raci.publishToValorem.publishButton' | translate}}</button>
    </div>
  </div>
  <div class="valorem-content" *ngIf="currentStep == 2">
    <div class="content-body" *ngIf="publishData && publishData.publishStatus">
      {{'raci.publishToValorem.dataSuccessfullyPushed' | translate}}
    </div>
    <div class="content-body" *ngIf="displayError || !publishData.publishStatus">
      {{'raci.publishToValorem.somethingWentWrong' | translate}} <br /><br />
      <p *ngIf="publishData" class="error-msg"> {{publishData.errorMessage}}</p>
      <section *ngIf="publishData && publishData.requiredFieldsMissing">
        {{'raci.publishToValorem.requiredFieldMsg' | translate}} <br /><br />
        <p *ngFor="let field of publishData.requiredFields">
          {{field.DisplayedName}}<span *ngIf="field.Message"> - {{field.Message}}</span>
        </p>
      </section>
    </div>
  </div>
</div>
